import { AccountInfo } from '@azure/msal-browser';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const truncateStringLargerThan = (str: string, maxLength: number) => {
  if (str.length > maxLength) {
    return `${str.substring(0, maxLength)}...`;
  }
  return str;
};

export const extractIdFromAccount = (account: AccountInfo): string => {
  if (account.idTokenClaims) {
    if (account.idTokenClaims.employee_id) return `employee_id://${account.idTokenClaims.employee_id}`;
    if (account.idTokenClaims.sub) return `sub://${account.idTokenClaims.sub}`;
  }
  return '';
};
